export const CUSTOMER_TYPES = { BUYER: "Alıcı", SELLER: "Satıcı", TENANT: "Kiracı", LANDLORD: "Mal Sahibi", INVESTOR: "Yatırımcı" };
export const TYPE_COLOR = {
  BUYER: "bg-emerald-500/10 text-emerald-700 border-emerald-500/30",
  SELLER: "bg-blue-500/10 text-blue-700 border-blue-500/30",
  TENANT: "bg-amber-500/10 text-amber-700 border-amber-500/30",
  LANDLORD: "bg-purple-500/10 text-purple-700 border-purple-500/30",
  INVESTOR: "bg-cyan-500/10 text-cyan-700 border-cyan-500/30",
};
export const SOURCES = { WALK_IN: "Ofise geldi", PHONE: "Telefonla aradı", ONLINE: "İnternet", REFERRAL: "Tavsiye", OTHER: "Diğer" };
export const NOTE_KINDS = { NOTE: "Not", PHONE: "Telefon görüşmesi", WALK_IN: "Ofis ziyareti" };
export const DESIRED_LISTING = { ANY: "Fark etmez", SALE: "Satılık", RENT: "Kiralık" };

export const scoreColor = (s) => (s >= 80 ? "bg-emerald-600" : s >= 65 ? "bg-amber-500" : "bg-slate-400");

export const timeAgo = (iso) => {
  if (!iso) return "-";
  const mins = Math.floor((Date.now() - new Date(iso).getTime()) / 60000);
  if (mins < 1) return "az önce";
  if (mins < 60) return `${mins} dk önce`;
  if (mins < 1440) return `${Math.floor(mins / 60)} saat önce`;
  if (mins < 43200) return `${Math.floor(mins / 1440)} gün önce`;
  return new Date(iso).toLocaleDateString("tr-TR");
};
